import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    background-color: var(--color-gray-4);
    padding: 10px 10px;
    border-top: 3px solid var(--color-gray-3);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    overflow: hidden;
`

export const Local = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`